/** Mirrors the knowledge/work/agenda API owner bypass, using the effective user only. */
export function canUseDomainPermission(
  { owner = false, readonly = false, permissions = [] },
  permission
) {
  if (!/^(work|knowledge|agenda)\./.test(permission)) return false;
  if (readonly && !permission.includes(".view_")) return false;
  return Boolean(owner) || permissions.includes(permission);
}
